import { post } from "@rails/request.js";

function trackSubmit(attrs = {}) {
  // eslint-disable-next-line no-console
  console.log("Track submit", attrs);
  post("/api/internal/v1/tracking_events", {
    body: {
      tracking_event: attrs,
    },
  });
}

// {
//   event: 'view',
//   subKind: 'course_recommendation_box',
//   session_id: '1234567890',
//   url: 'https://www.example.com/homepage',
//   meta: {
//     reco_version: '1.0',
//     recommendations: [
//       {type: 'Course', id:'123', reco_type: 'interaction_based'},
//       {type: 'Course', id:'234', reco_type: 'semantic_based'},
//       {type: 'Course', id:'123', reco_type: 'interaction_based'},
//       {type: 'Course', id:'234', reco_type: 'semantic_based'}
//     ]
//   }
// }
export function trackView(subKind, url, meta) {
  trackSubmit({ kind: "view", subKind, url, meta });
}

// {
//   event: 'click',
//   subtype: 'course_recommendation_box',
//   session_id: '1234567890',
//   url: 'https://www.example.com/course/1234567890',
//   meta: {
//     id: '1234567890',
//     type: 'Course'
//   }
// }

export function trackClick(subKind, url, meta) {
  trackSubmit({ kind: "click", subKind, url, meta });
}
